import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import translations from '../translations';

export const useTranslation = () => {
  const { language } = useContext(LanguageContext);

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (let k of keys) {
      if (value && value.hasOwnProperty(k)) {
        value = value[k];
      } else {
        return key; // Return the key if translation is not found
      }
    }

    if (typeof value === 'function') {
      return value(params.count);
    }

    if (typeof value === 'string') {
      return value;
    }

    return key; // Return the key if translation is not a string or function
  };

  return { t };
};
